export class NoticeToVacateSignature {
  constructor (
      public Name: string = '',
      public Email: string = '',
      public Address: string ='',
      public NTVCanceled: boolean = null,
      public LeaseInStatus: boolean = null
  ) { }
}
